import * as React from 'react';
import { Grid, List } from '@material-ui/core';
import { vote } from '../../../model/vote'
import { VoteItem } from './VoteItem';
import Button from '../../../ui-components/Button/TabButton';
import { Up, Down } from '../../../ui-components/Icons';
interface IProps {
    votes: vote[];
    classes: any;
}

const showVotes = (voteFiltered: vote[], classes: any) => {
    return (
        <List style={{ overflowY: "auto", maxHeight: "500px" }}>
            {voteFiltered.map(m => <VoteItem vote={m} classes={classes} />)}
        </List>
    )
}

export const Votes = (props: IProps) => {
    const [current, setCurrent] = React.useState("");
    const [voteFiltered, filterVote] = React.useState([]);
    React.useEffect(() => {
        const votesSelected = props.votes.filter(v => v.choiceSelected === current);
        filterVote(votesSelected);
    }, [current, props.votes]);
    //const votesTest = [...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered,...voteFiltered]
    return (
        <Grid container>
            <Grid item sm={12}>
                <Button className={current === "YES" ? props.classes.voteYesButtonSelected : ""} selected={current === "YES"} onClick={() => { current === "YES" ? setCurrent("") : setCurrent("YES"); }}>
                    UTENTI CON VOTAZIONE SI {current === "YES" ? <Up className={props.classes.voteExpansionIcon} /> : <Down className={props.classes.voteExpansionIcon} />}
                </Button>
            </Grid>
            {current === "YES" && <Grid item sm={12}>
                {showVotes(voteFiltered, props.classes)}
            </Grid>}
            <Grid item sm={12}>
                <Button className={current === "NO" ? props.classes.voteNoButtonSelected : ""} selected={current === "NO"} onClick={() => {
                    current === "NO" ? setCurrent("") : setCurrent("NO");
                }}>UTENTI CON VOTAZIONE NO {current === "NO" ? <Up className={props.classes.voteExpansionIcon} /> : <Down className={props.classes.voteExpansionIcon} />}</Button>
            </Grid>
            {current === "NO" && <Grid item sm={12}>
                {showVotes(voteFiltered, props.classes)}
            </Grid>}
        </Grid>
    );
}


